import { useEffect, useRef, useState } from 'react'

import { ApexOptions } from 'apexcharts'
import ReactApexChart from 'react-apexcharts'
import { useTranslation } from 'react-i18next'

import { getLineChartOptionsAndData } from './dataConverter'
import { ChartData } from '@/Atomic/Organisms/Charts/acBar/dataConverter'
import '../ChartError.scss'
import '../Charts.scss'

interface Param {
  salesData: ChartData | undefined
  showLegend: boolean
}

export function AcLinesChart({
  salesData = undefined,
  showLegend = false,
}: Param) {
  const { t } = useTranslation()
  const chartRef = useRef<HTMLDivElement>(null)
  const [isExpanded, setIsExpanded] = useState(false)

  useEffect(() => {
    const wrapper = chartRef.current?.closest('.chartWrapper')
    if (!wrapper) return

    // Initialize state based on current class
    const initialExpanded = wrapper.classList.contains('chartExpanded')
    if (initialExpanded !== isExpanded) {
      setIsExpanded(initialExpanded)
    }

    const observer = new MutationObserver(() => {
      const nowExpanded = wrapper.classList.contains('chartExpanded')
      setIsExpanded(nowExpanded)
    })

    observer.observe(wrapper, {
      attributes: true,
      attributeFilter: ['class'],
    })

    return () => observer.disconnect()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (!salesData) {
    return null
  }

  let options
  let data

  try {
    const result = getLineChartOptionsAndData(salesData, showLegend, isExpanded)
    options = result.options
    data = result.data
  } catch (error) {
    console.error(
      'Error processing line chart data:',
      error instanceof Error ? error.message : 'Unknown error',
    )
    return (
      <div className="chart-error">
        {t('components.dashboard.chart.unableToRender')}
      </div>
    )
  }

  return (
    <div ref={chartRef} className="AcLinesChart">
      <ReactApexChart
        options={options as unknown as ApexOptions}
        series={data}
        type="line"
        width="100%"
        height="100%"
      />
    </div>
  )
}
